<template>
    <div>
        <h1 style="font-size: 24px; color: black;">分享统计</h1>
        <el-card class="form-container" style="margin-top: 25px" shadow="never">
            <el-row  type="flex"  align="middle" > 
                <el-col :span="6">
                        <span class="margin-left-10" > 日期：</span>
                        <el-date-picker
                                v-model="queryData.timeDate"
                                type="daterange"
                                :clearable="false"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd">
                        </el-date-picker>
                </el-col>
                <el-col :span="8">
                        <span class="margin-left-10" > 渠道：</span>
                        <el-select v-model="queryData.channelId" @change="selectGoodsByChannelId($event)" clearable
                                    placeholder="请选择">
                                <el-option value="0" label="全部"></el-option>
                                <el-option v-for="item in channelList" :label="item.name" :key="item.id" :value="item.id"></el-option>
                            </el-select>
                            <el-select v-model="queryData.subChannelId" clearable @clear="clearValue" placeholder="请选择">
                                <el-option value="0" label="全部"></el-option>
                                <el-option v-for="item in subChannelList" :label="item.name" :key="item.id"
                                        :value="item.subChannel"></el-option>
                            </el-select>
                </el-col>
                <el-col :span="3">
                    <el-button type="primary"  @click="query">查询</el-button>
                    <el-button type="primary"  @click="exportExcel">导出</el-button>
                    <el-tooltip class="item" effect="dark" content="显隐列" placement="top" v-if="colConfig!=undefined">
                        <el-dropdown trigger="click" :hide-on-click="false" style="padding-left: 12px">
                            <el-button size="mini" circle icon="el-icon-menu"/>
                            <el-dropdown-menu slot="dropdown" style="overflow:scroll;height:500px;">
                                <template v-for="(item,index) in colConfig" >
                                <el-dropdown-item :key="index" ><el-checkbox :checked="item.isShow" @change="colShow($event,item.id)" :label="item.name"></el-checkbox></el-dropdown-item>
                                </template>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </el-tooltip> 
                </el-col>
            </el-row>
            <el-row  type="flex"  align="middle" >
                    <el-col :span="4">
                        <span style="width:70px" > 用户类型：</span>
                        <el-select v-model="queryData.user" clearable   placeholder="请选择">
                            <el-option v-for="item in users" :label="item.name" :key="item.id" :value="item.id"></el-option>
                        </el-select>
                </el-col>
                <el-col :span="4">
                        <span style="width:70px" > 版本：</span>
                        <el-select v-model="queryData.version" multiple filterable @change="checkParam1($event)" placeholder="请选择/输入">
                            <el-option
                                    v-for="item in versionList"
                                    :key="item.versionCode"
                                    :label="item.versionName"
                                    :value="item.versionCode"
                                    :disabled="item.disabled">
                            </el-option>
                    </el-select>
                </el-col>
            </el-row>
        </el-card>
        <h1>
            <el-table
                    border
                    :data="chatReportList"
                    :header-cell-style="{background:'#282828'}"
                    ref="filterTable"
                    max-height="820">
                <el-table-column v-if="colConfig[0].isShow"   label="日期" prop="dt" align="center" ></el-table-column>
                <el-table-column v-if="colConfig[1].isShow"   label="用户类型" prop="userType" align="center" :formatter="userTypeFormatter"  ></el-table-column>
                <el-table-column v-if="colConfig[2].isShow"   label="版本号" prop="versionCode" align="center"   ></el-table-column>
                <el-table-column v-if="colConfig[3].isShow"   label="渠道号" prop="channel_id" align="center" :formatter="channelFormatter"></el-table-column>
                <el-table-column v-if="colConfig[4].isShow"   label="子渠道号" prop="sub_channel_id" align="center"></el-table-column>
                <el-table-column v-if="colConfig[5].isShow"   label="分享dialog总曝光次数" prop="shareDialogExposureTimes" align="center"></el-table-column>
                <el-table-column v-if="colConfig[6].isShow"  label="分享dialog总曝光人数" prop="shareDialogExposurePerson" align="center"></el-table-column>
                <el-table-column v-if="colConfig[7].isShow"  label="分享总次数" prop="shareTimes" align="center"></el-table-column>
                <el-table-column v-if="colConfig[8].isShow"  label="分享总人数" prop="sharePerson" align="center"></el-table-column>
                <el-table-column v-if="colConfig[9].isShow"  label="分享游戏次数" prop="shareGameTimes" align="center"></el-table-column>
                <el-table-column v-if="colConfig[10].isShow"  label="分享游戏人数" prop="shareGamePerson" align="center"></el-table-column>
                <el-table-column v-if="colConfig[11].isShow"  label="分享应用次数" prop="shareAppTimes" align="center"></el-table-column>
                <el-table-column v-if="colConfig[12].isShow"  label="分享应用人数" prop="shareAppPerson" align="center"></el-table-column>
                <el-table-column v-if="colConfig[13].isShow"  label="微信分享人数" prop="wxSharePerson" align="center"></el-table-column>
                <el-table-column v-if="colConfig[14].isShow"  label="朋友圈分享人数" prop="momentsSharePerson" align="center"></el-table-column>
                <el-table-column v-if="colConfig[15].isShow"  label="QQ分享人数" prop="qqSharePerson" align="center"></el-table-column>
                <el-table-column v-if="colConfig[16].isShow"  label="QQ空间分享人数" prop="qqZoneSharePerson" align="center"></el-table-column>
                <el-table-column v-if="colConfig[17].isShow"  label="复制链接分享人数" prop="copyLinkSharePerson" align="center"></el-table-column>
                <el-table-column v-if="colConfig[18].isShow"  label="分享游戏dialog曝光次数" prop="shareGameDialogExposureTimes" align="center"></el-table-column>
                <el-table-column v-if="colConfig[19].isShow"  label="分享应用dialog曝光次数" prop="shareAppDialogExposureTimes" align="center"></el-table-column>
                <el-table-column v-if="colConfig[20].isShow"  label="分享游戏dialog总曝光人数" prop="shareGameDialogExposurePerson" align="center"></el-table-column>
                <el-table-column v-if="colConfig[21].isShow"  label="分享应用dialog总曝光人数" prop="shareAppDialogExposurePerson" align="center"></el-table-column>
                <el-table-column v-if="colConfig[22].isShow"  label="分享应用至微信次数" prop="shareAppToWxTimes" align="center"></el-table-column>
                <el-table-column v-if="colConfig[23].isShow"  label="分享应用至微信人数" prop="shareAppToWxPerson" align="center"></el-table-column>
                <el-table-column v-if="colConfig[24].isShow"  label="分享应用至朋友圈次数" prop="shareAppToMomentsTimes" align="center"></el-table-column>
                <el-table-column v-if="colConfig[25].isShow"  label="分享应用至朋友圈人数" prop="shareAppToMomentsPerson" align="center"></el-table-column>
                <el-table-column v-if="colConfig[26].isShow"  label="分享应用至QQ次数" prop="shareAppToQQTimes" align="center"></el-table-column>
                <el-table-column v-if="colConfig[27].isShow"  label="分享应用至QQ人数" prop="shareAppToQQPerson" align="center"></el-table-column>
                <el-table-column v-if="colConfig[28].isShow"  label="分享应用至QQ空间次数" prop="shareAppToQQZoneTimes" align="center"></el-table-column>
                <el-table-column v-if="colConfig[29].isShow"  label="分享应用至QQ空间人数" prop="shareAppToQQZonePerson" align="center"></el-table-column>
                <el-table-column v-if="colConfig[30].isShow"  label="复制分享应用链接次数" prop="shareAppToCopyLinkTimes" align="center"></el-table-column>
                <el-table-column v-if="colConfig[31].isShow"  label="复制分享应用链接人数" prop="shareAppToCopyLinkPerson" align="center"></el-table-column>
                <el-table-column v-if="colConfig[32].isShow"  label="原生分享应用次数" prop="shareAppToNativeTimes" align="center"></el-table-column>
                <el-table-column v-if="colConfig[33].isShow"  label="原生分享应用人数" prop="shareAppToNativePerson" align="center"></el-table-column>
                <el-table-column v-if="colConfig[34].isShow"  label="分享游戏至微信次数" prop="shareGameToWxTimes" align="center"></el-table-column>
                <el-table-column v-if="colConfig[35].isShow"  label="分享游戏至微信人数" prop="shareGameToWxPerson" align="center"></el-table-column>
                <el-table-column v-if="colConfig[36].isShow"  label="分享游戏至朋友圈次数" prop="shareGameToMomentsTimes" align="center"></el-table-column>
                <el-table-column v-if="colConfig[37].isShow"  label="分享游戏至朋友圈人数" prop="shareGameToMomentsPerson" align="center"></el-table-column>
                <el-table-column v-if="colConfig[38].isShow"  label="分享游戏至QQ次数" prop="shareGameToQQTimes" align="center"></el-table-column>
                <el-table-column v-if="colConfig[39].isShow"  label="分享游戏至QQ人数" prop="shareGameToQQPerson" align="center"></el-table-column>
                <el-table-column v-if="colConfig[40].isShow"  label="分享游戏至QQ空间次数" prop="shareGameToQQZoneTimes" align="center"></el-table-column>
                <el-table-column v-if="colConfig[41].isShow"  label="分享游戏至QQ空间人数" prop="shareGameToQQZonePerson" align="center"></el-table-column>
                <el-table-column v-if="colConfig[42].isShow"  label="复制分享游戏链接次数" prop="shareGameToCopyLinkTimes" align="center"></el-table-column>
                <el-table-column v-if="colConfig[43].isShow"  label="复制分享游戏链接人数" prop="shareGameToCopyLinkPerson" align="center"></el-table-column>
                <el-table-column v-if="colConfig[44].isShow"  label="原生分享游戏次数" prop="shareGameToNativeTimes" align="center"></el-table-column>
                <el-table-column v-if="colConfig[45].isShow"  label="原生分享游戏人数" prop="shareGameToNativePerson" align="center"></el-table-column>
            </el-table>
        </h1>
        <div>
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page.page"
                    :page-sizes="[20,50,100]"
                    :page-size="page.size"
                    layout="total, sizes, prev, pager, next"
                    :total="page.totalElements">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {
        downloadData,
        channelList,
        searchShareReport,
        copyList
    } from "@/http/api";
    import utils from '@/utils'
    export default {
        name: "ShareReport",
        data(){
            return{
                users: [{id: -1, name: '全部'},
                    {id: 1, name: '新用户'},
                    {id: 0, name: '老用户'}],
                channelList: [],
                subChannelList: [],                    
                queryData:{
                    user: null,
                    channelId: null,
                    subChannelId: null,
                    timeDate: ['', ''],
                    version:[],
                },
                page: {
                    size: 20,
                    page: 1,
                    totalElements: null
                },
                versionList:[],
                chatRoomList:[],
                chatReportList:[],
                colConfig:[
                     {id:0  ,name:"日期" ,prop:"dt" ,isShow:true}
                    ,{id:1  ,name:"用户类型" ,prop:"userType" ,isShow:true}
                    ,{id:2  ,name:"版本号" ,prop:"versionCode" ,isShow:true}
                    ,{id:3  ,name:"渠道号" ,prop:"channelId" ,isShow:true}
                    ,{id:4  ,name:"子渠道号" ,prop:"subChannelId" ,isShow:true}
                    ,{id:5  ,name:"分享dialog总曝光次数" ,prop:"shareDialogExposureTimes" ,isShow:true}
                    ,{id:6  ,name:"分享dialog总曝光人数" ,prop:"shareDialogExposurePerson" ,isShow:true}
                    ,{id:7  ,name:"分享总次数" ,prop:"shareTimes" ,isShow:true}
                    ,{id:8  ,name:"分享总人数" ,prop:"sharePerson" ,isShow:true}
                    ,{id:9  ,name:"分享游戏次数" ,prop:"shareGameTimes" ,isShow:true}
                    ,{id:10  ,name:"分享游戏人数" ,prop:"shareGamePerson" ,isShow:true}
                    ,{id:11  ,name:"分享应用次数" ,prop:"shareAppTimes" ,isShow:true}
                    ,{id:12  ,name:"分享应用人数" ,prop:"shareAppPerson" ,isShow:true}
                    ,{id:13  ,name:"微信分享人数" ,prop:"wxSharePerson" ,isShow:true}
                    ,{id:14 ,name:"朋友圈分享人数" ,prop:"momentsSharePerson" ,isShow:true}
                    ,{id:15  ,name:"QQ分享人数" ,prop:"qqSharePerson" ,isShow:true}
                    ,{id:16  ,name:"QQ空间分享人数" ,prop:"qqZoneSharePerson" ,isShow:true}
                    ,{id:17  ,name:"复制链接分享人数" ,prop:"copyLinkSharePerson" ,isShow:true}
                    ,{id:18 ,name:"分享游戏dialog曝光次数" ,prop:"shareGameDialogExposureTimes" ,isShow:true}
                    ,{id:19  ,name:"分享应用dialog曝光次数" ,prop:"shareAppDialogExposureTimes" ,isShow:true}
                    ,{id:21  ,name:"分享游戏dialog总曝光人数" ,prop:"shareGameDialogExposurePerson" ,isShow:true}
                    ,{id:22 ,name:"分享应用dialog总曝光人数" ,prop:"shareAppDialogExposurePerson" ,isShow:true}
                    ,{id:23 ,name:"分享应用至微信次数" ,prop:"shareAppToWxTimes" ,isShow:true}
                    ,{id:24 ,name:"分享应用至微信人数" ,prop:"shareAppToWxPerson" ,isShow:true}
                    ,{id:25 ,name:"分享应用至朋友圈次数" ,prop:"shareAppToMomentsTimes" ,isShow:true}
                    ,{id:26 ,name:"分享应用至朋友圈人数" ,prop:"shareAppToMomentsPerson" ,isShow:true}
                    ,{id:27 ,name:"分享应用至QQ次数" ,prop:"shareAppToQQTimes" ,isShow:true}
                    ,{id:28 ,name:"分享应用至QQ人数" ,prop:"shareAppToQQPerson" ,isShow:true}
                    ,{id:29 ,name:"分享应用至QQ空间次数" ,prop:"shareAppToQQZoneTimes" ,isShow:true}
                    ,{id:30,name:"分享应用至QQ空间人数" ,prop:"shareAppToQQZonePerson" ,isShow:true}
                    ,{id:31 ,name:"复制分享应用链接次数" ,prop:"shareAppToCopyLinkTimes" ,isShow:true}
                    ,{id:32 ,name:"复制分享应用链接人数" ,prop:"shareAppToCopyLinkPerson" ,isShow:true}
                    ,{id:33 ,name:"原生分享应用次数" ,prop:"shareAppToNativeTimes" ,isShow:true}
                    ,{id:34 ,name:"原生分享应用人数" ,prop:"shareAppToNativePerson" ,isShow:true}
                    ,{id:35 ,name:"分享游戏至微信次数" ,prop:"shareGameToWxTimes" ,isShow:true}
                    ,{id:36 ,name:"分享游戏至微信人数" ,prop:"shareGameToWxPerson" ,isShow:true}
                    ,{id:37 ,name:"分享游戏至朋友圈次数" ,prop:"shareGameToMomentsTimes" ,isShow:true}
                    ,{id:38 ,name:"分享游戏至朋友圈人数" ,prop:"shareGameToMomentsPerson" ,isShow:true}
                    ,{id:39 ,name:"分享游戏至QQ次数" ,prop:"shareGameToQQTimes" ,isShow:true}
                    ,{id:40  ,name:"分享游戏至QQ人数" ,prop:"shareGameToQQPerson" ,isShow:true}
                    ,{id:41  ,name:"分享游戏至QQ空间次数" ,prop:"shareGameToQQZoneTimes" ,isShow:true}
                    ,{id:42  ,name:"分享游戏至QQ空间人数" ,prop:"shareGameToQQZonePerson" ,isShow:true}
                    ,{id:43  ,name:"复制分享游戏链接次数" ,prop:"shareGameToCopyLinkTimes" ,isShow:true}
                    ,{id:44  ,name:"复制分享游戏链接人数" ,prop:"shareGameToCopyLinkPerson" ,isShow:true}
                    ,{id:45  ,name:"原生分享游戏次数" ,prop:"shareGameToNativeTimes" ,isShow:true}
                    ,{id:46  ,name:"原生分享游戏人数" ,prop:"shareGameToNativePerson" ,isShow:true}

                    ]
            }
        },
        methods:{
            userTypeFormatter: function (row, column, cellValue){
                var temp="其他"
                this.users.forEach( item => {
                    if(item.id==cellValue){
                        temp=item.name;
                        } 
                })
                return temp
                }, 
            channelFormatter: function (row, column, cellValue){
                var temp=""
                // console.log(this.channelList)
                this.channelList.forEach( item => {
                    if(item.id==cellValue){
                        temp=item.name;
                        } 
                })
                // if(cellValue==='-1'){
                //     temp=cellValue
                // }
                return temp
                },
            selectGoodsByChannelId(val) {
                // this.watchTag = val;
                if (val !== null && val !== '' && val !== undefined && val !== '0' && val !== '-1') {
                    this.subChannelList = this.channelList.filter(channel => channel.id === val)[0].children.filter(subChannel => subChannel.state === 1);
                }
                if (val === '0' || val === '-1') {
                    this.subChannelList = [];
                }
                this.queryData.subChannelId=null;
            },
            clearValue(){
                this.queryData.subChannelId=null;
            },
            handleSizeChange(size) {
                this.page.size = size;
                this.query();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.query();
            },
            exportExcel() {
                let fileName = new Date().toLocaleString() + '分享统计导出.xlsx';
                downloadData(
                    '/share/exportReportExcel',
                    Object.assign(this.queryData),
                    fileName
                )
            },
            query(){
                this.queryData.page = this.page.page;
                this.queryData.size = this.page.size;
                if (this.queryData.timeDate === null) {
                    this.queryData.timeDate = ['',''];
                }
                this.queryData.startTime = this.queryData.timeDate[0] ===''?null:this.queryData.timeDate[0];
                this.queryData.endTime = this.queryData.timeDate[1]===''?null:this.queryData.timeDate[1];
                searchShareReport(this.queryData).then(resp=>{
                    this.chatReportList=resp.data.info.content;
                    this.page.totalElements =resp.data.info.totalElements;
                });
            },
            colShow(value,id){
                // console.log(id)
                // console.log(this.colConfig)
                this.colConfig[id].isShow=value
            },
            checkParam1(val){
                let _this = this;
                if (val.indexOf('') > -1){
                    this.versionList.forEach(function (version) {
                        _this.$set(version,'disabled',true);
                        _this.queryData.version=['']
                    });
                }else {
                    this.versionList.forEach(function (version) {
                        _this.$set(version,'disabled',false);
                    });
                }
            },
        },
        created() {
            this.queryData.timeDate=[utils.TodayUtil.getToday(),utils.TodayUtil.getToday()];
            channelList().then(resp => {
            this.channelList = resp.data.info;
            });
            copyList().then(resp=>{
                this.versionList=resp.data.info;
                this.versionList.unshift({versionCode:'',versionName:'全部'});
            });
            this.query();
        },
        watch:{
            colConfig: {
                deep:true,
                handler() {
                  console.log("重新渲染表格");
                   this.$nextTick(() => { //在数据加载完，重新渲染表格
                    this.$refs['filterTable'].doLayout();
                    }
                   )
                }
            }
        }
    }
</script>

<style scoped>
    .sub-sub9{ position: relative; left: 110px}
</style>
